import { createSelector } from '@reduxjs/toolkit';
import { getResultProperty } from '../result-templates/result-templates-helpers.js';
export function firstSearchExecutedSelector(state) {
    return state.search.response.searchUid !== '';
}
export function resultFromFieldSelector(state, contentIdKey, contentIdValue) {
    return state.search.results.find((result) => getResultProperty(result, contentIdKey) === contentIdValue);
}
export const selectSearchActionCause = createSelector((state) => state.search, (state) => {
    return state?.searchAction?.actionCause || '';
});
